<template>
  <div class="home">
    <innerHeader v-if="!isMobile"></innerHeader>
    <AppHeader v-if="isMobile" />
    <ResponsiveContainer>
      <div class="main">
        <!--cloumnId控制contentList  Tab的active -->
        <contentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="8"
          v-if="!isMobile"
          class="bg"
        >
          <div slot="main_content">
            <div class="content_top">
              <div class="article_con">
                <div class="link_con">
                  <div
                    class="link_item"
                    v-for="(l, index) in friendLink"
                    :key="index"
                  >
                    <img :src="l.coverImg" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </contentList>
        <AppcontentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="8"
          v-if="isMobile"
          class="appbg"
        >
          <div slot="main_content">
            <div class="app_content_top">
              <div class="article_con">
                <div class="link_con">
                  <div
                    class="link_item"
                    v-for="(l, index) in friendLink"
                    :key="index"
                  >
                    <img :src="l.coverImg" />
                  </div>
                </div>
              </div>
            </div></div
        ></AppcontentList>
        <!-- <paginations
          :current-page.sync="page.current"
          @current-change="currentChange"
          :page-size="page.size"
          :total="page.total"
        ></paginations> -->
      </div>
    </ResponsiveContainer>
    <Footer v-if="!isMobile" />
    <innerAppFooter v-else />
  </div>
</template>

<script>
import innerHeader from '@/components/innerHeader.vue';
import AppHeader from '@/components/AppHeader';
import Footer from '@/components/Footer.vue';
import innerAppFooter from '@/components/innerAppFooter';
import ResponsiveContainer from '@/components/ResponsiveContainer';
import contentList from '@/components/contentList';
import AppcontentList from '@/components/AppcontentList';
import paginations from '@/components/Pagination.vue';
import responsiveMixin from '@/mixins/responsiveMixin';
import { partnerTab } from '@/const';
import { fetchConentList } from '@/assets/api';
export default {
  name: 'Partner',
  mixins: [responsiveMixin],
  components: {
    innerHeader,
    AppHeader,
    innerAppFooter,
    Footer,
    ResponsiveContainer,
    contentList,
    AppcontentList,
    paginations,
  },
  data() {
    return {
      contentBg: require('../../assets/img/homeimgs/presi_bg.png'),
      contentBg2: require('../../assets/img/appImg/presi_bg.png'),
      tabList: partnerTab,
      value: '',
      page: { current: 1, size: 10, total: 20 },
      cloumnId: null, //栏目id
      friendLink: [
        { img: require('../../assets/img/link1.png') },
        { img: require('../../assets/img/link1.png') },
        { img: require('../../assets/img/link1.png') },
        { img: require('../../assets/img/link1.png') },
        { img: require('../../assets/img/link1.png') },
        { img: require('../../assets/img/link1.png') },
        { img: require('../../assets/img/link1.png') },
        { img: require('../../assets/img/link1.png') },
        { img: require('../../assets/img/link1.png') },
        { img: require('../../assets/img/link1.png') },
        { img: require('../../assets/img/link1.png') },
        { img: require('../../assets/img/link1.png') },
        { img: require('../../assets/img/link1.png') },
        { img: require('../../assets/img/link1.png') },
      ],
      id: '',
      cloumnList: [],
    };
  },
  mounted() {
    this.cloumnList = this.$store.state.navTree;
    this.getList();
  },
  methods: {
    handletuijian(v, index) {
      this.value = v.name;
      this.tuijianActive = index;
    },
    tabChagnge(column, cloumnId) {
      this.cloumnId = cloumnId;
      this.$router.push({ path: column.path });
      // this.getList();
    },
    currentChange(e) {
      this.page.current = e;
      // this.getList();
    },
    // 合作伙伴
    getList() {
      let id = '';
      this.cloumnList.map((c) => {
        if (c.accessPath == '/partner') {
          id = c.id;
        }
      });
      const data = {
        columnIds: id,
        size: 999,
        current: 1,
      };
      fetchConentList(data).then((res) => {
        this.friendLink = res.records;
      });
    },
    toDetail(id) {
      this.$router.push({ path: `/theaterDetail?id=${id}` });
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  .content_top {
    padding: 1.5rem 0;
    .article_con {
      width: 100%;
      box-sizing: border-box;

      .link_con {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 25px; /* 设置间距 */
        .link_item {
          width: calc((100% - 100px) / 5);
          height: 6.875rem;
          margin-bottom: 2.375rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        &::after {
          content: '';
          flex: auto;
          width: calc((100% - 100px) / 5);
          /* 或者使用固定宽度，与项目宽度相同 */
          /* width: 30%; */
        }
      }
    }
  }

  .app_content_top {
    padding: 2rem 0;
    box-sizing: border-box;
    .article_con {
      // background: #fff;
      width: 100%;
      box-sizing: border-box;
      min-height: 55.6vh;

      .link_con {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 0.6667rem; /* 设置间距 */
        .link_item {
          width: calc((100% - 1.3333rem) / 3);
          height: 3.6667rem;
          margin-bottom: 0.8333rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        &::after {
          content: '';
          flex: auto;
          width: calc((100% - 1.3333rem) / 3);
          /* 或者使用固定宽度，与项目宽度相同 */
          /* width: 30%; */
        }
      }
    }
  }
}
::v-deep {
  .content_top {
    #search_input.el-input__inner {
      background: #f0f0f0;
      border-radius: 94px;
      height: 5rem;
      padding-left: 4.75rem;
      border: none;
      font-size: 1.5rem;
    }
    #search_input::placeholder {
      color: #6b6d7a; /* 修改颜色 */
      font-size: 1.5rem; /* 修改字体大小 */
      line-height: 4rem;
    }
    .el-divider__text {
      background: none;
      font-size: 1.125rem;
    }
  }
  .app_content_top {
    #search_input.el-input__inner {
      background: #f0f0f0;
      border-radius: 94px;
      height: 4rem;
      padding-left: 3.3333rem;
      border: none;
      font-size: 1.1667rem;
    }
    #search_input::placeholder {
      color: #6b6d7a; /* 修改颜色 */
      font-size: 1.1667rem; /* 修改字体大小 */
      line-height: 4rem;
    }
    .el-divider__text {
      background: none;
      font-size: 1.125rem;
    }
  }
}
.appbg {
  width: 100%;
  background: url('../../assets/img/appImg/article_bg.png') no-repeat left
    bottom/100% auto;
}
.bg {
  width: 100%;
  background: url('../../assets/img/homeimgs/article_bg.png') no-repeat left
    bottom/100% auto;
}
</style>
